import { Link } from 'react-router-dom';

const serviceDomains = [
  {
    title: 'Cloud Services',
    services: [
      'Instance provisioning and VPC creation',
      'Application and data migration from on-premises to cloud',
      'Database-as-a-Service deployment and optimization'
    ],
    partnerships: ['Huawei', 'Oracle']
  },
  {
    title: 'Server & Storage',
    services: [
      'Infrastructure deployment and end-to-end solutions',
      'Virtualization, VM migrations, and high availability design',
      'Data replication and engineered system integration'
    ],
    partnerships: ['Oracle', 'Huawei', 'Dell EMC']
  },
  {
    title: 'Big Data',
    services: ['Big data platform deployments', 'Data engineering and pipeline development'],
    partnerships: ['Huawei Big Data Solutions', 'Oracle Big Data']
  },
  {
    title: 'Databases',
    services: [
      'Oracle RAC deployment and database migration',
      'Disaster recovery setup and GoldenGate replication',
      'Advanced security, auditing, performance tuning'
    ],
    partnerships: ['Huawei', 'Oracle']
  },
  {
    title: 'Identity & Access Management',
    services: [
      'Oracle Identity and Access Management implementation',
      'Application integration and customization',
      'Oracle SOA Suite and Business Intelligence deployments'
    ]
  },
  {
    title: 'Middleware',
    services: ['Oracle WebLogic Server implementation and support', 'Application server optimization and tuning']
  }
];

const ProfessionalServices = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>Professional Services</h1>
          <p>
            Nexus IT delivers mission-critical technology services that empower organizations with secure, reliable, and
            high-performing IT infrastructure tailored to business outcomes.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="section-header">
            <span className="tagline">End-to-End Delivery</span>
            <h2 className="section-title">Service Domains &amp; Partnerships</h2>
          </div>

          <div className="list-grid">
            {serviceDomains.map((domain) => (
              <div key={domain.title}>
                <h3>{domain.title}</h3>
                <strong>Services:</strong>
                <ul>
                  {domain.services.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                {domain.partnerships && (
                  <>
                    <strong>Partnerships:</strong>
                    <ul>
                      {domain.partnerships.map((partner) => (
                        <li key={partner}>{partner}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Partner with Nexus IT Experts</h2>
              <p>Our consultants deliver the skill, governance, and partnerships required to modernize enterprise IT.</p>
            </div>
            <Link className="btn btn-white" to="/contact">
              Engage Our Team
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProfessionalServices;
